export default "__VITE_ASSET__DmQzSWcQ__"